/**
 * Bundle 141 - Settings landing page.
 * Route: /admin/settings
 */
import React from 'react';
import AdminSectionLandingPage from './AdminSectionLandingPage';

const AdminSettingsLandingPage = () => (
  <AdminSectionLandingPage
    section="settings"
    testidPrefix="admin-settings-landing"
  />
);

export default AdminSettingsLandingPage;
